import chipStatusLabel from './chipStatusLabel'
import chipStatusColor from './chipStatusColor'
import chipStatusBgColor from './chipStatusBgColor'

export default {
  chipStatusLabel,
  chipStatusColor,
  chipStatusBgColor,
}
